import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "../../apis/axios";
import { getToken } from "../../utilities";

const useUploadMedia = ({ refreshUrl = "", url = "", onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const upload = useMutation((data) => _uploadMedia(data), {
    onError: (err) => {
      onError?.(err);
    },
    onSuccess: (data) => { // 'data' here is response.data from axios
      {
        refreshUrl && queryClient.invalidateQueries(refreshUrl);
      }
      onSuccess?.(data); // Pass the full response data to the onSuccess callback
    },
  });
  const _uploadMedia = async (getFormData) => {
    let fd = new FormData();
    for (var key in getFormData) {
      if (key === "thumbnail") {
        for (let i = 0; i < getFormData["thumbnail"].length; i++) {
          fd.append("thumbnail", getFormData["thumbnail"][i]);
        }
      } else if (key === "file") {
        if (Array.isArray(getFormData[key])) {
          for (let i = 0; i < getFormData[key].length; i++) {
            fd.append("file", getFormData[key][i]);
          }
        } else {
          fd.append("file", getFormData[key]);
        }
      } else {
        fd.append(key, getFormData[key]);
      }
    }
    const response = await axios({
      method: "POST",
      data: fd,
      url: `/${url}`,
      headers: { Authorization: getToken() ? `Bearer ${getToken()}` : "" },
    });
    return response.data; // Return the response data
  };
  return { upload };
};

export default useUploadMedia;
